
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {
    PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE,
    PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_SINGER_WRITE,
    PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE,
    PERMISSION_TALENTS_PROFILE_EDITOR_WRITE,
    PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE,
    PERMISSION_TALENTS_PROFILE_BOOKER_WRITE
  } from '../../../../constants'
import WithAjax from '../../../common/helpers/WithAjax'
import WithNotify from '../../../common/helpers/WithNotify'
import {clearSkillVendorCurrentProfile} from '../../../../actions/pages/skillvendor-page'
import ProtectedElement from '../../../common/helpers/ProtectedElement'

class TestAnswersBox extends Component {
  constructor() {
    super()

    this.extendTests = this.extendTests.bind(this)
  }

  getPermissionsToCheck(profileData) {
    switch (profileData.ProfileType) {
      case 'Director':
        return PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE;
      case 'Translator':
        return PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE;
      case 'VoiceActor':
        return PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE;
      case 'Singer':
        return PERMISSION_TALENTS_PROFILE_SINGER_WRITE;
      case 'Adaptor':
        return PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE;
      case 'Lyricist':
        return PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE;
      case 'Editor':
        return PERMISSION_TALENTS_PROFILE_EDITOR_WRITE;
      case 'SoundEngineer':
        return PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE;
      case 'Booker':
        return PERMISSION_TALENTS_PROFILE_BOOKER_WRITE;
      default:
        return null;
    }
  }

  extendTests() {
    let url = 'skillVendors/' + this.props.skillVendorId + '/profiles/' + this.props.profileData.ProfileType + '/extendtests';

    this.props.ajax.put(url, null, null, () => {
        this.props.clearSkillVendorCurrentProfile();

        let message = 'New link was generated.';
        this.props.notify(message);
      })
  }

  render() {
    var profileData = this.props.profileData;
    var areAnswers = profileData.TestAnswers && profileData.TestAnswers.length > 0;

    let permissionToCheck = this.getPermissionsToCheck(profileData);

    return (
      <div className="col-md-6 widget">
        <div className="title">Qualification test</div>
        <div className="row">
          <div className="col">
            {profileData.TestContent &&
              <div>Test: <a href={profileData.TestContent.TestFileUrl}>{profileData.TestContent.Name}</a></div>
            }
            {profileData.UserTestLink &&
              <div>Link: <a href={profileData.UserTestLink}>{profileData.UserTestLink}</a></div>
            }
            {profileData.UserTestLinkExpirationData &&
              <div>Expires: {profileData.UserTestLinkExpirationData}
                <ProtectedElement permission={permissionToCheck}>
                  <button className="btn btn-rounded btn-primary" style={{marginLeft:10}} onClick={() => { if (window.confirm('Are you sure you want to extend qualification test and generate new link?')) this.extendTests();}}>Extend</button>
                </ProtectedElement>
              </div>
            }
            {profileData.TestPhase1Content &&
              <div>Test 1st phase: <a href={profileData.TestPhase1Content.TestFileUrl}>{profileData.TestPhase1Content.Name}</a></div>
            }
            {profileData.TestPhase2Content &&
              <div>Test 2nd phase: <a href={profileData.TestPhase2Content.TestFileUrl}>{profileData.TestPhase2Content.Name}</a></div>
            }

            {areAnswers === false && profileData.Status !== 'Incomplete'
              && <div>No test requested</div>}

            {areAnswers === false && profileData.Status === 'Incomplete'
              && <div>No test results yet</div>}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {areAnswers && profileData.TestAnswers.map((testAnswer, index) => {
              return <div key={index} className="mb-2">
                <div className="row">
                  <div className="col">
                    <i className="ion-icon ion-icon-1x ion-document"></i>
                    <a href={testAnswer.FileUrl} className="ml-1">{testAnswer.FileName}</a>
                    <br />
                    <span className="ml-3"><small>Added: {testAnswer.CreatedOn}</small></span>
                    <span className="ml-3"><small>Updated: {testAnswer.ModifiedOn}</small></span>
                  </div>
                </div>
              </div>
              })
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  profileData: state.skillVendorPage.currentProfile
})
const mapDispatchToProps = dispatch => ({
  clearSkillVendorCurrentProfile() { dispatch(clearSkillVendorCurrentProfile()) }
})
 export default compose(
   connect(mapStateToProps, mapDispatchToProps),
   WithNotify,
   WithAjax)(TestAnswersBox)